/*
 * DRIVLY-UI React Components
 * @license MIT
 */
import{useCallback as e,useState as t,useRef as o,useEffect as n}from"react";import{useCallbackRef as r}from"../../react-use-callback-ref/dist/index.js";function a({prop:a,defaultProp:c,onChange:u=(()=>{})}){const[f,l]=function({defaultProp:e,onChange:a}){const c=t(e),[u]=c,f=o(u),l=r(a);return n((()=>{f.current!==u&&(l(u),f.current=u)}),[u,f,l]),c}({defaultProp:c,onChange:u}),s=void 0!==a,i=s?a:f,p=r(u);return[i,e((e=>{if(s){const t="function"==typeof e?e(a):e;t!==a&&p(t)}else l(e)}),[s,a,l,p])]}export{a as useControllableState};
//# sourceMappingURL=index.js.map
